import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const FAQS = [{
  q: '¿Es fiel a la Biblia?',
  a: 'Sí. Cada historia está basada en el texto bíblico e indica el pasaje en que se apoya, para que puedan ir juntos a la Biblia real y profundizar. Como todo formato narrativo, resume y adapta el lenguaje para su edad — por eso lo posicionamos como el mejor puente hacia la Escritura completa, nunca como su reemplazo. (Muchos padres nos cuentan que la leyeron entera antes de dársela a sus hijos: nos parece perfecto.)'
}, {
  q: '¿Es para católicos o evangélicos?',
  a: 'Las historias centrales de la fe cristiana —Creación, Patriarcas, Éxodo, Reyes, Profetas, vida, muerte y resurrección de Jesús— son compartidas por todas las tradiciones cristianas, y son el corazón de este cómic.'
}, {
  q: '¿Para qué edad es ideal?',
  a: 'El punto dulce es de 6 a 14 años: los más chicos la disfrutan acompañados (las imágenes cuentan la historia incluso antes de saber leer), y de 8 en adelante la leen solos. Y un secreto: a los adultos que nunca pudieron terminar la Biblia también les encanta.'
}, {
  q: '¿No es “más tiempo de pantalla”?',
  a: 'Puedes elegir: leerla en tablet como cuento antes de dormir, o imprimirla en casa y regalar un libro físico. Y si es en pantalla, es la pantalla trabajando a tu favor: el mismo dispositivo que lo distrae, ahora le cuenta la historia de Dios.'
}, {
  q: '¿Cómo la recibo?',
  a: 'Al confirmar el pago, llega a tu email un enlace de descarga inmediata. La guardas en tu celular, tablet o computadora, y es tuya para siempre. Si tienes cualquier problema, te ayudamos por WhatsApp.'
}, {
  q: '¿Puedo imprimirla?',
  a: 'Sí, incluye permiso de impresión para uso familiar. Muchos abuelos la imprimen y la encuadernan para regalarla en Comuniones, cumpleaños o Navidad.'
}, {
  q: '¿Y si a mi hijo no le gusta?',
  a: 'Tienes 7 días de garantía total. Si no lo atrapa, escríbenos y te devolvemos el dinero completo.'
}];
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-mist" data-id="element-34" data-mp="286repdamihvo">
      <div className="mx-auto max-w-3xl px-4 py-16 md:py-20" data-id="element-35" data-mp="285prkagc24xl">
        <h2 className="text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[38px]" data-id="element-36" data-mp="2c9e0oxkm58ky">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-37" data-mp="2h5uxsh9sixa6">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-card border border-card-border bg-white shadow-soft" data-id="element-38" data-mp="2qx8uyie9rl05" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-39" data-mp="2vyoda2p2bdeu">
                  <span className="font-display text-lg font-bold text-deep-blue" data-id="element-40" data-mp="tagbcwx9tb4l">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 flex-none text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="o9sdbramju0v" />
                </button>
                <AnimatePresence initial={false} data-id="element-42" data-mp="1c068hqoia8zo">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-43" data-mp="180dv90o63enz">
                      <p className="px-5 pb-5 text-[16px] text-ink/75" data-id="element-44" data-mp="1vox2dcvhdleh">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}